import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";

var TeamApply =
/** @class */
function () {
  function TeamApply(apply) {
    this.logo = (apply === null || apply === void 0 ? void 0 : apply.logo) ? apply.logo : null;
    this.name = (apply === null || apply === void 0 ? void 0 : apply.name) ? apply.name : ''; // 使用-1用于实现全国

    this.city_id = apply ? apply.city_id ? apply.city_id : [-1] : [];
    this.level_id = (apply === null || apply === void 0 ? void 0 : apply.level_id) ? apply.level_id : null;
    this.description = (apply === null || apply === void 0 ? void 0 : apply.description) ? apply.description : '';
    this.qr_code = (apply === null || apply === void 0 ? void 0 : apply.group_qr_code) && (apply === null || apply === void 0 ? void 0 : apply.monitor_qr_code) ? [apply.group_qr_code, apply.monitor_qr_code] : [];
    this.photos = (apply === null || apply === void 0 ? void 0 : apply.photos) ? apply.photos : [];
    this.we_chat_id = (apply === null || apply === void 0 ? void 0 : apply.we_chat_id) ? apply.we_chat_id : null;
  }

  TeamApply.prototype.toRaw = function () {
    var _a;

    var self = this;
    return {
      logo: self.logo ? self.logo.key : null,
      name: self.name,
      city_id: self.city_id && self.city_id.length && self.city_id[0] === -1 ? null : self.city_id,
      level_id: self.level_id,
      description: self.description,
      group_qr_code: self.qr_code[0] ? self.qr_code[0].key : null,
      monitor_qr_code: self.qr_code[1] ? self.qr_code[1].key : null,
      photos: (_a = self.photos) === null || _a === void 0 ? void 0 : _a.map(function (photo) {
        return photo.key;
      }),
      we_chat_id: self.we_chat_id
    };
  };

  return TeamApply;
}();

export default TeamApply;